import { useGetStudentsForOrganisationQuery } from '@/app/redux/endpoints/students';
import { useCurrentOrganisationId } from '@/app/redux/hooks/organisation';
import { useMemo } from 'react';

export function useStudents() {
  const { currentOrganisationId } = useCurrentOrganisationId();

  const {
    data: students = [],
    isLoading,
    isFetching,
    error,
  } = useGetStudentsForOrganisationQuery(currentOrganisationId!, {
    skip: !currentOrganisationId,
  });

  const studentsById = useMemo(() => {
    const byId: Map<string, (typeof students)[number]> = new Map();
    for (const s of students) byId.set(s.id, s);
    return byId;
  }, [students]);

  return {
    students,
    studentsById,
    isLoading,
    isFetching,
    error,
  };
}
